<template>
    <el-card>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <el-breadcrumb-item>Mis Informes</el-breadcrumb-item>
        </el-breadcrumb>

		<div class="loading" v-if="loading" v-loading="loading"></div>
		<template v-if="!loading">
            <el-row>
                <el-col :span="7">
                    <app-table-paginate 
                        :routeEdit="false" 
                        :routeDelete="false" 
                        :routeView="false" 
                        :routeSelect="true" 
                        :tableQuery="tableData" 
                        :tableColumns="headers"
                        :multipleSelect="false">
                    </app-table-paginate>
                </el-col>
                <el-col :span="1">
                    <p class="invisible">a</p>
                </el-col>
                <el-col :span="17">
                    <transition name="fade" mode="out-in" v-if="viewReports">
                        <app-informes  :project="viewReports"></app-informes>
                    </transition>
                </el-col>
            </el-row>
        </template>
    </el-card>
</template>

<script>
	import ApiService from '@/common/api.service'
    import tablaConPaginador from '@/components/Dashboard/commons/tablaConPaginador'
    import Informes from '@/components/Dashboard/InformesProyecto'
	import { mapGetters } from 'vuex'

    export default {
        name: 'misinformes',
        components: {
            'app-table-paginate': tablaConPaginador,
            'app-informes': Informes
        },
        computed: {
			...mapGetters(['currentUser'])
		},
        created () {
            this.viewReports == false ? window.localStorage.removeItem('analiticaproyectoActivo') : this.viewReport(this.viewReports, this.name) ;
			this.$root.$on('select', (id) => {
                this.viewReports = false
                setTimeout(() => {
                    this.viewReports = id
                }, 500);
            })
			this.$root.$on('select', (id, row) => this.viewReport(id, row.proyecto))
			this.init()
        },
        data () {
            return  {
				loading: true,
				headers: [
                {
                    'prop': 'proyecto',
                    'label': 'Proyecto'
                }],
				field: {},
				tableQuery: {},
				relationship: [],
                routeView: null,
                viewReports: false
            }
        },
        watch: {
			$route(to) {
				this.loading = true
				this.tableQuery = {}
				this.headers = []
				this.init()
			}
		},
        methods: {
			init() {
				this.getTableData()
            },
            async getTableData() {

                ApiService.post("public/v1", {
					token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['proyectos.id', 'proyectos.proyecto'],
                    table: 'proyectos',
                    inner: [
                        'users_projects, project_id, id, proyectos',
                        'users, id, user_id, users_projects' 
                    ],
                    where: ' users.id = ' + this.currentUser.id,
                    order: [' proyectos.id DESC'],

                }).then(response => {
                    if(response.data == 'Algo ha fallado'){
                        this.tableData = []
                    }else{
	    				this.tableData = response.data
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 200);
                })
            },
            viewReport(id, name) {
                this.viewReports = false
                this.$root.$emit('sidebar', id);
                setTimeout(() => {
                    this.viewReports = id
                    this.name = name
                }, 500);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/misinformes.vue